























import { Vue, Component, Prop } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';

@Component({ components: { CabeceraModal } })
export default class CabeceraModalEdicion extends Vue {
  @Prop({ default: false }) permitirGuard: Boolean;

  guard() {
    this.$emit('guardarCrear');
  }
}
